import axios from 'axios';
import {authHeader} from "../helpers/auth-header";

const login = (email, password) => {
    return axios.post('/api/account/login', { email: email, password: password })
        .then(
            (res) => {
                // TODO MAKE CONFIG PROP FROM MINUTES
                const dateNow = new Date().getTime() + (30 * 60000);
                localStorage.setItem('expirationToken', dateNow.toString());
                localStorage.setItem('auth-token', res.data.token);
                return res.data;
            }
        );
};

const logout = () => {
    localStorage.removeItem('expirationToken');
    localStorage.removeItem('auth-token');
};

const getList = () => {
    return axios.get(`/api/account/getlist`, { headers: authHeader() })
        .then(res => { return res.data; })
};

const getById = (id) => {
    return axios.get(`/api/account/GetById/${id}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const resetPassword = (userId) => {
    return axios.patch(`/api/account/resetpassword/${userId}`, {}, { headers: authHeader() })
        .then(res => { return res.data })
};

const changePassword = (changePasswordModel) => {
    return axios.patch(`/api/account/changePassword`, changePasswordModel, { headers: authHeader() })
        .then(res => { return res.data });
}

const activateUser = (userId) => {
    return axios.delete(`/api/account/enable/${userId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const deactivateUser = (userId) => {
    return axios.delete(`/api/account/delete/${userId}`, { headers: authHeader() })
        .then(res => { return res.data })
};

const createUser = (createModel) => {
    return axios.post(`/api/account/create`, createModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const editUser = (editModel) => {
    return axios.patch(`/api/account/update/${editModel.id}`, editModel, { headers: authHeader() })
        .then(res => { return res.data })
};

const handleResponse = (response) => {
    return  Promise.reject(new Error('fails'));
};

export const userService = {
    login,
    logout,
    getList,
    getById,
    createUser,
    editUser,
    resetPassword,
    activateUser,
    deactivateUser,
    handleResponse,
    changePassword
};
